import React, { useState } from 'react';
import { NavDropdown } from 'react-bootstrap';

const DropdownMenu = ({ title, categories }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  // Determine if any category has special content
  const hasSpecialContent = categories.some(category => category.embedVideo || category.footerLink);

  const dropdownContainerStyle = {
  display: 'flex',
  alignItems: 'flex-start',  // Make sure children align at the top.
  width: hasSpecialContent ? '650px' : 'auto', // Keep or adjust based on needs.
  maxHeight: '400px',
  overflowY: 'auto',  // Vertically scrollable if overall content exceeds.
  padding: '1rem',  // Adjusted for demonstration.
};

const categoriesContainerStyle = {
  display: 'flex',
  flex: '1 1 auto', // Give it flexibility but also a basis for growth.
  overflowX: 'auto',  // Allow horizontal scrolling for categories.
  minWidth: '250px', // Prevents too much squeezing, adjust as needed.
  padding: '0 10px 0 0', // Padding adjusted for demonstration purposes.
};

const specialContentStyle = {
  flex: '0 0 300px', // Example fixed width for specialContent, adjust as needed.
  display: 'flex',
  flexDirection: 'column',
  padding: '0 10px',
};

  const dropdownColStyle = {
    flex: '0 0 auto', // This ensures that the column doesn't shrink
    padding: '0 10px', // Maintain padding for breathing room
  };


  // Function to render special content (to avoid duplication in logic)
  const renderSpecialContent = (category) => (
    <>
      {category.embedVideo && (
        <iframe
          src={category.embedVideo.url}
          title={category.embedVideo.title}
          width='100%'
          height='200'
          frameBorder='0'
          allowFullScreen
          style={{ marginBottom: '10px' }} // Margin at the bottom of the video
        ></iframe>
      )}
      {category.footerLink && (
        <NavDropdown.Item href={category.footerLink.href}>{category.footerLink.text}</NavDropdown.Item>
      )}
    </>
  );

  return (
    <NavDropdown
      title={<span className="nav-dropdown-title">{title}</span>}
      id='basic-nav-dropdown'
      show={showDropdown}
      onMouseEnter={() => setShowDropdown(true)}
      onMouseLeave={() => setShowDropdown(false)}
    >
      <div style={dropdownContainerStyle}> {/* Top-level container */}
        <div style={categoriesContainerStyle}> {/* Container for categories */}
          {categories.map((category, index) => (
            <div key={index} style={{ ...dropdownColStyle, display: 'flex', flexDirection: 'column' }}>
              <NavDropdown.ItemText  className='nav-dropdown-category-title'>{category.title}</NavDropdown.ItemText>
              {category.items.map((item, itemIndex) => (
                <NavDropdown.Item key={itemIndex} href={item.href} className='nav-dropdown-item'>
                  {item.text}
                </NavDropdown.Item>
              ))}
            </div>
          ))}
        </div>
        {hasSpecialContent && ( // This now appears to the right
          <div style={specialContentStyle}>
            {categories.filter(category => category.embedVideo || category.footerLink).map(renderSpecialContent)}
          </div>
        )}
      </div>
    </NavDropdown>
  );
};
export default DropdownMenu;